import moment from "moment";
import "moment/locale/fr";
import i18n from "utils/i18n";

export const getLocale = () => {
  return i18n.language || "fr";
};

export const formatDate = (date, dateFormat = "ddd DD MMM") => {
  return moment(date).utc(date).locale(getLocale()).format(dateFormat);
};
